/** @format */

import { Script } from 'gatsby';
import React, { memo, ReactNode } from 'react';
import { StringParam, useQueryParam } from 'use-query-params';
import { NAME_PORTAL_CODE } from './utils/gatsby/constants';

interface Props {
  children: ReactNode;
}

export const BaseHead = memo(({ children }: Props) => {
  const [portalCode = NAME_PORTAL_CODE] = useQueryParam('portalCode', StringParam);
  const isExternalPortalCode = portalCode !== NAME_PORTAL_CODE;

  return (
    <>
      {!isExternalPortalCode && (
        <Script
          id="ze-snippet"
          strategy="idle"
          src="https://static.zdassets.com/ekr/snippet.js?key=5bc50942-a5f6-4b71-8fae-95da00d04253"
        />
      )}
      <meta name="theme-color" content="#FFFFFF" />
      {children}
    </>
  );
});
